/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 minimalspider.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Minimalspider(props) {
  const { nodes, materials } = useGLTF('/media/models/minimalspider.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Tomb_Spider.geometry} material={materials['Material_0.001']} position={[0.016, 1.076, -0.073]} rotation={[0, 1.294, 0]} scale={0.042} />
    </group>
  )
}

useGLTF.preload('/media/models/minimalspider.glb')
